export type SOEntryReportAttributeType = 'text' | 'boolean' | 'checkbox' | 'select' | 'number' | string

export interface SOEntryReportAttributeOptionInput {
  ID?: string | number
  Name?: string
  value?: string | number
  label?: string
  so_item_attribute_option_id?: string | number
  so_item_attribute_option_value?: string
}

export interface SOEntryReportAttributeOption {
  ID: string | number | undefined
  Name: string
}

export interface SOEntryReportAttributeInput {
  attribute_id?: string | number
  name?: string
  type?: SOEntryReportAttributeType
  required?: boolean | number | string
  display_order?: number | string
  value?: string | number | boolean | null
  options?: SOEntryReportAttributeOptionInput[]
}

export interface SOEntryReportAttribute {
  attribute_id: string | number | undefined
  name: string
  type: SOEntryReportAttributeType
  required: boolean
  display_order: number
  value: string | number
  booleanValue: boolean
  options: SOEntryReportAttributeOption[]
}

export interface SerializedSOEntryReportAttribute {
  attribute_id: string | number | undefined
  value: string
}

export function normalizeSOEntryReportAttributes(
  attributes: SOEntryReportAttributeInput[] = []
): SOEntryReportAttribute[] {
  return (attributes || [])
    .map((attribute, index): SOEntryReportAttribute => {
      const type: SOEntryReportAttributeType = attribute.type || 'text'
      let value: string | number = (attribute.value ?? '') as string | number
      let booleanValue = false

      if (type === 'boolean' || type === 'checkbox') {
        booleanValue = value === '1' || value === 1 || (value as unknown) === true
        value = booleanValue ? '1' : '0'
      }

      return {
        attribute_id: attribute.attribute_id,
        name: attribute.name || '',
        type,
        required: !!attribute.required,
        display_order: Number(attribute.display_order ?? index),
        value,
        booleanValue,
        options: Array.isArray(attribute.options)
          ? attribute.options.map(
              (option): SOEntryReportAttributeOption => ({
                ID:
                  option.ID ??
                  option.value ??
                  option.so_item_attribute_option_value ??
                  option.so_item_attribute_option_id,
                Name:
                  option.Name ??
                  option.label ??
                  option.so_item_attribute_option_value ??
                  String(option.value ?? '')
              })
            )
          : []
      }
    })
    .sort((a, b) => a.display_order - b.display_order)
}

export function isSOEntryReportAttributeValid(attribute: SOEntryReportAttribute | null | undefined): boolean {
  if (!attribute) return false
  if (attribute.type === 'boolean') return typeof attribute.booleanValue === 'boolean'
  return attribute.value !== null && attribute.value !== undefined && String(attribute.value).trim() !== ''
}

export function serializeSOEntryReportAttributes(
  attributes: SOEntryReportAttribute[] = []
): SerializedSOEntryReportAttribute[] {
  return attributes.map((attribute) => ({
    attribute_id: attribute.attribute_id,
    value: attribute.type === 'boolean' ? (attribute.booleanValue ? '1' : '0') : String(attribute.value ?? '')
  }))
}
